import { useTranslation } from "@privacy/translations";

export const useGetSortByKey = () => {
  const { language } = useTranslation();

  return <Key extends string, Obj extends Record<Key, string>>(obj: Obj[], sortKey: Key) =>
    [...obj].sort((a, z) => a[sortKey].localeCompare(z[sortKey], language));
};
